<template>
  <section
    class="component-cf612bc7"
    resmed-component-name="info_50/50_icon-line_text_2video_cta"
    v-bind:style="{
      'background-image': `url(${acf.layout['background-image']})`,
      'background-color': acf.layout['background-color'],
    }"
  >
    <div
      class="component"
      v-bind:class="[`text-color-${acf.layout['text-color']}`]"
    >
      <div class="container px-xs-sm-2">
        <div class="row justify-content-center">
          <div class="col col-lg-8">
            <eyebrow-icon
              v-if="acf.eyebrowicon"
              v-bind:eyebrowicon="acf.eyebrowicon"
              v-bind:align="'center'"
            ></eyebrow-icon>
            <h2>{{ acf.headline }}</h2>
          </div>
        </div>
        <div class="row align-items-center">
          <div class="col-md-6 mb-4 mb-md-0">
            <figure class="embed-responsive embed-responsive-16by9">
              <iframe
                class="embed-responsive-item"
                v-bind:src="`//players.brightcove.net/2750693505001/${acf.player}_default/index.html?videoId=${acf['id-1']}`"
                frameborder="0"
                allowfullscreen
                webkitallowfullscreen
                mozallowfullscreen
                allow="encrypted-media"
                style="
                  position: absolute;
                  top: 0px;
                  right: 0px;
                  bottom: 0px;
                  left: 0px;
                  width: 100%;
                  height: 100%;
                "
              ></iframe>
            </figure>
          </div>
          <div class="col-md-6">
            <figure class="embed-responsive embed-responsive-16by9">
              <iframe
                class="embed-responsive-item"
                v-bind:src="`//players.brightcove.net/2750693505001/${acf.player}_default/index.html?videoId=${acf['id-2']}`"
                frameborder="0"
                allowfullscreen
                webkitallowfullscreen
                mozallowfullscreen
                allow="encrypted-media"
                style="
                  position: absolute;
                  top: 0px;
                  right: 0px;
                  bottom: 0px;
                  left: 0px;
                  width: 100%;
                  height: 100%;
                "
              ></iframe>
            </figure>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "component-cf612bc7", // info_50/50_icon-line_text_2video_cta
  props: ["acf"],
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-cf612bc7 {
  padding: 6rem 0;
  background-size: cover;
  background-repeat: no-repeat;
}

.component {
  &.text-color-black {
    // default
  }

  &.text-color-white {
    h2 {
      &:before {
        background-color: $cc-resmed-white;
      }
    }
  }

  h2 {
    position: relative;
    margin-bottom: 3.5rem;
    text-align: center;

    @extend %eyebrow-center;
  }

  figure {
    border-radius: 6px;
    box-shadow: -3px 0.875rem 12px 0 rgba(0, 0, 0, 0.125);
    overflow: hidden;
  }
}
</style>